import angular from "angular"
import "../edition/edition"
import "front-end-web-commons"
import "./productCategory.less"


export default angular.module("productCategoryModule", ["editionModule", "nlgDualListModule"])